// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  min-height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
  font-family: "Inter", sans-serif;
  color: #000;
  margin: 0;
  padding: 0;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

body {
  background-color: #f3f4f6;
}

a {
  color: inherit;
  text-decoration: none;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

img {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.swiper-button-prev,
.swiper-button-next {
  color: white !important;
}

.swiper-pagination-bullet-active {
  background-color: white !important;
}

.css-vg6wcs-MuiStepIcon-text {
  fill: white !important;
}

::-webkit-scrollbar {
  width: 8px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background-color: rgb(203, 203, 203);
  border-radius: 2px;
}

@keyframes entryX {
  from {
    transform: translateX(-100px);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes entryY {
  from {
    transform: translateY(-100px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;EACX,SAAS;EACT,UAAU;EACV,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,oCAA4B;UAA5B,4BAA4B;AAC9B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE;IACE,6BAA6B;IAC7B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\r\n\r\nhtml,\r\nbody {\r\n  min-height: 100vh;\r\n  max-width: 100vw;\r\n  overflow-x: hidden;\r\n  font-family: \"Inter\", sans-serif;\r\n  color: #000;\r\n  margin: 0;\r\n  padding: 0;\r\n  padding-left: 0 !important;\r\n  padding-right: 0 !important;\r\n}\r\n\r\nbody {\r\n  background-color: #f3f4f6;\r\n}\r\n\r\na {\r\n  color: inherit;\r\n  text-decoration: none;\r\n}\r\n\r\ninput[type=\"number\"]::-webkit-inner-spin-button,\r\ninput[type=\"number\"]::-webkit-outer-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\nimg {\r\n  user-select: none !important;\r\n}\r\n\r\n.swiper-button-prev,\r\n.swiper-button-next {\r\n  color: white !important;\r\n}\r\n\r\n.swiper-pagination-bullet-active {\r\n  background-color: white !important;\r\n}\r\n\r\n.css-vg6wcs-MuiStepIcon-text {\r\n  fill: white !important;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 6px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n  background-color: rgb(203, 203, 203);\r\n  border-radius: 2px;\r\n}\r\n\r\n@keyframes entryX {\r\n  from {\r\n    transform: translateX(-100px);\r\n    opacity: 0;\r\n  }\r\n\r\n  to {\r\n    transform: translateX(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes entryY {\r\n  from {\r\n    transform: translateY(-100px);\r\n    opacity: 0;\r\n  }\r\n\r\n  to {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
